import logotype from "@assets/images/rarraba-footer.svg";
import Image from "next/image";
import FooterColsText from "./FooterColsText";

export default function Footer() {
	return (
		<footer className="bg-navy-blue-deep fixed right-0 bottom-0 left-0 flex h-full flex-col justify-end">
			<div id="footer-logotype">
				<div className="flex flex-col gap-y-10 px-3.5 sm:hidden sm:px-0">
					<FooterColsText />
				</div>
				<div className="px-3.5 pt-10 pb-5 sm:px-[2.375rem] sm:py-[3.125rem]">
					<div className="relative aspect-[1368/272] w-full">
						<Image
							src={logotype}
							alt="Rarraba logo"
							fill
							sizes="95vw"
							className="object-contain opacity-[35%] sm:opacity-[0.2]"
						/>
					</div>
				</div>
			</div>
		</footer>
	);
}
